import { Box, Typography } from '@mui/material';
import colors from 'assets/theme/colors';
import React from 'react';

interface NumberBoxProps {
    value: number | string | undefined;
    label: string;
    color?: string;
}

export const NumberBox: React.FC<NumberBoxProps> = (props) => {
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
                background: `linear-gradient(45deg, ${
                    props.color && colors[props.color]
                        ? colors[props.color]?.main
                        : 'text.secondary'
                } 30%, ${
                    props.color && colors[props.color]
                        ? colors[props.color]?.focus
                        : 'text.secondary'
                } 90%)`,
                width: '40%',
                borderRadius: 8,
            }}
            pl={2}
            pr={2}
        >
            <Typography
                sx={{
                    display: 'inline',
                    padding: '0.5rem',
                    textAlign: 'center',
                }}
                component="div"
                variant="h5"
                color={'#fff'}
            >
                {props.value || '-'}
            </Typography>
            <Typography
                sx={{
                    display: 'inline',
                    padding: '0.5rem',
                    textAlign: 'center',
                }}
                component="div"
                variant="button"
                color={'#fff'}
            >
                {props.label}
            </Typography>
        </Box>
    );
};
